import { useMemo } from "react";
import { useResearch } from "@/store/researchStore";

export function useAgentSwarm() {
  const agents = useResearch((s) => s.agents);
  const plan = useResearch((s) => s.plan);

  const list = useMemo(() => Object.values(agents), [agents]);
  const active = useMemo(
    () => list.filter((a) => a.status !== "done" && a.status !== "failed" && a.status !== "stopped"),
    [list],
  );
  const done = useMemo(() => list.filter((a) => a.status === "done"), [list]);

  return { agents: list, active, done, plan };
}
